//EDITED
export const batchGetFieldInstances = /* GraphQL */ `
	query BatchGetFieldInstances($ids: [ID]) {
		batchGetFieldInstances(ids: $ids) {
			id
			formInstance
			formGroup
			fieldTemplate {
				id
				formTemplate
				inputType
				header
				tableField
				rollLinkId
				action
				actionData
				rowOrder
				csvKey
				identityRole
				tableFields {
					nextToken
				}
				options {
					nextToken
					items {
						id
						label
						value
						docId
						linkedId
						group
						readGroups
						exportActions
						exportData
						createdAt
						updatedAt
					}
				}
				placeholder
				optionsOrder
				docId
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldTemplateId
			value
			altInstance {
				id
				value
				group

				authors
			}
			imageId
			image {
				id
				key
				rotation
				dpi
				aspectX
				aspectY
				createdAt
				updatedAt
				formGroup
				project
				group
			}
			altInstanceId
			tableField
			fieldsOrder
			sortingPriority
			tableFields {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					imageId
					image {
						id
						key
						rotation
						dpi
						aspectX
						aspectY
						createdAt
						updatedAt
						formGroup
						project
						group
					}
					fieldsOrder
					sortingPriority
					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}

			notes
			authors
			editing
			group
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const batchGetFormGroupsForPhotoLogs = /* GraphQL */ `
	query BatchGetFormGroups($ids: [ID]) {
		batchGetFormGroups(ids: $ids) {
			id
			formInstances {
				items {
					id
					group
					formTemplateId
					formGroup
					createdAt
					updatedAt
					fieldInstances {
						items {
							id
							formInstance
							formGroup
							fieldTemplateId
							fieldTemplate {
								id
								formTemplate
								inputType
								header
								tableField
								action
								actionData
								rowOrder
								rollLinkId
								csvKey
								identityRole
								tableFields {
									nextToken
								}
								options {
									nextToken
									items {
										id
										label
										value
										linkedId
										docId
										group
										readGroups
										exportActions
										exportData
										createdAt
										updatedAt
									}
								}
								placeholder
								optionsOrder
								docId
								group
								readGroups
								createdAt
								updatedAt
							}
							value
							altInstanceId
							tableField
							fieldsOrder
							sortingPriority
							notes
							authors
							imageId
							image {
								id
								key
								rotation
								dpi
								aspectX
								aspectY
								createdAt
								updatedAt
								formGroup
								project
								group
							}
							editing
							group
							createdAt
							updatedAt
						}
						nextToken
					}
				}
				nextToken
			}
			formOrder
			type
			group
			projectId
			name
			users
			syncedAt
			lastUpdatedBy
		}
	}
`;

export const batchGetFormGroupsThatArePhotologs = /* GraphQL */ `
	query BatchGetFormGroups($ids: [ID]) {
		batchGetFormGroups(ids: $ids) {
			id
			formInstances {
				items {
					id
					formGroup
					formTemplate {
						id
						fieldTemplates {
							items {
								id
								tableFields {
									items {
										id
										rollLinkId
									}
								}
							}
						}
					}
				}
				nextToken
			}
		}
	}
`;

export const getFormGroupDocument = /* GraphQL */ `
	query GetFormGroup($id: ID!) {
		getFormGroup(id: $id) {
			id
			formOrder
			type
			group
			projectId
			name
			users
			createdAt
			updatedAt
		}
	}
`;

export const batchGetFormTemplates = /* GraphQL */ `
	query BatchGetFormTemplates($ids: [ID]) {
		batchGetFormTemplates(ids: $ids) {
			id
			template
			type
			description
			fieldsOrder
			formTemplateGroup
			imagesPerPage
			exportType
			createdAt
			updatedAt
			deleted
			exportInstruction
			templateName
			version
			versionName
			publish
			createdBy
			updatedBy
			projectId
			group
			readGroups
		}
	}
`;

// EDITED
export const getFormTemplate = /* GraphQL */ `
	query GetFormTemplate($id: ID!, $nextToken: String) {
		getFormTemplate(id: $id) {
			id
			template
			templateName
			description
			formTemplateGroup
			fieldsOrder
			type
			exportType
			projectId
			version
			versionName
			publish
			fieldTemplates(nextToken: $nextToken) {
				items {
					id
					formTemplate
					inputType
					exportType
					exportActions
					header
					tableField
					action
					actionData
					rowOrder
					deleted
					optionsOrder
					exportData
					docId
					group
					readGroups
					createdAt
					updatedAt
					continuationDataId
					placeholder
					pixelFollowing
					pixelInitial
					rowsAllowed
					totalExtraLines
					font
					fontSize
					bold
					rollLinkId
					version
					baseFieldTemplate
					csvKey
					identityRole
					options {
						nextToken
						items {
							id
							label
							linkedId
							fieldTemplateId
							formTemplate
							value
							docId
							group
							readGroups
							exportActions
							exportData
							createdAt
							updatedAt
						}
					}
					tableFields {
						items {
							id
							formTemplate
							inputType
							exportType
							exportActions
							version
							baseFieldTemplate
							header
							tableField
							action
							actionData
							rowOrder
							deleted
							optionsOrder
							exportData
							docId
							group
							csvKey
							identityRole
							readGroups
							createdAt
							updatedAt
							continuationDataId
							placeholder
							pixelFollowing
							pixelInitial
							rowsAllowed
							totalExtraLines
							font
							fontSize
							bold
							rollLinkId
							options {
								nextToken
								items {
									id
									label
									linkedId
									value
									formTemplate
									docId
									fieldTemplateId
									group
									readGroups
									exportActions
									exportData
									createdAt
									updatedAt
								}
							}
							legacyHeader
						}
						nextToken
					}
					legacyHeader
				}
				nextToken
			}
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;

//EDITED
export const listFormTemplates = /* GraphQL */ `
	query ListFormTemplates($filter: ModelFormTemplateFilterInput, $limit: Int, $nextToken: String) {
		listFormTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				template
				templateName
				type
				exportType
				description
				fieldsOrder
				publish
				version
				versionName
				projectId
				formTemplateGroup
				imagesPerPage
				deleted
				exportInstruction
				group
				readGroups
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

// EDITED
export const getFieldContinuationData = /* GraphQL */ `
	query GetFieldContinuationData($id: ID!) {
		getFieldContinuationData(id: $id) {
			id
			continuationActions
			fieldTemplateId
			formTemplateId
			instanceToContinueOn
			parentFormTemplateId
			group
			readGroups
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const listFormTemplatesOffline = /* GraphQL */ `
	query ListFormTemplates($filter: ModelFormTemplateFilterInput, $limit: Int, $nextToken: String) {
		listFormTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				template
				type
				description
				fieldsOrder
				formTemplateGroup
				imagesPerPage
				exportType
				createdAt
				updatedAt
				deleted
				exportInstruction
				group
				readGroups
			}
			nextToken
		}
	}
`;

//EDITED
export const listFormTemplatesForTransfer = /* GraphQL */ `
	query ListFormTemplates($filter: ModelFormTemplateFilterInput, $limit: Int, $nextToken: String) {
		listFormTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				template
				description
				fieldsOrder
				fieldTemplates {
					items {
						id
						formTemplate
						inputType
						header
						csvKey
						identityRole
						action
						actionData
						options {
							nextToken
							items {
								id
								label
								value
								linkedId
								docId
								group
								readGroups
								exportActions
								exportData
								createdAt
								updatedAt
							}
						}
						optionsOrder
						docId
						group
						readGroups
						tableField
						placeholder
						tableFields {
							items {
								formTemplate
								inputType
								header
								csvKey
								identityRole
								rollLinkId
								options {
									nextToken
									items {
										id
										label
										value
										linkedId
										docId
										group
										readGroups
										exportActions
										exportData
										createdAt
										updatedAt
									}
								}
								optionsOrder
								placeholder
								docId
								tableField
								rowOrder
								group
								readGroups
								legacyHeader
								createdAt
								updatedAt
								id
							}
							nextToken
						}
						rowOrder
						legacyHeader
						createdAt
						updatedAt
					}
					nextToken
				}
				group
				version
				readGroups
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const getFieldTemplate = /* GraphQL */ `
	query GetFieldTemplate($id: ID!, $nextToken: String) {
		getFieldTemplate(id: $id) {
			id
			formTemplate
			inputType
			exportType
			exportActions
			header
			tableField
			action
			actionData
			rowOrder
			deleted
			optionsOrder
			exportData
			docId
			group
			readGroups
			createdAt
			updatedAt
			continuationDataId
			placeholder
			pixelFollowing
			pixelInitial
			rowsAllowed
			totalExtraLines
			font
			fontSize
			bold
			rollLinkId
			csvKey
			identityRole
			legacyHeader
			tableFields {
				items {
					id
					formTemplate
					inputType
					header
					actionData
					rollLinkId
					tableField
					action
					rowOrder
					optionsOrder
					docId
					csvKey
					identityRole
					placeholder
					group
					readGroups
					createdAt
					updatedAt
				}
				nextToken
			}
			options(nextToken: $nextToken) {
				items {
					id
					fieldTemplateId
					formTemplate
					label
					value
					docId
					group
					readGroups
					exportData
					exportActions
					linkedId
					deleted
					createdAt
					updatedAt
				}
				nextToken
			}
		}
	}
`;

// Edited
export const listFieldTemplatesOffline = /* GraphQL */ `
	query ListFieldTemplates($filter: ModelFieldTemplateFilterInput, $limit: Int, $nextToken: String) {
		listFieldTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				formTemplate
				inputType
				exportType
				exportActions
				header
				tableField
				action
				csvKey
				identityRole
				actionData
				rowOrder
				deleted
				optionsOrder
				exportData
				docId
				group
				readGroups
				createdAt
				updatedAt
				continuationDataId
				placeholder
				pixelFollowing
				pixelInitial
				rowsAllowed
				totalExtraLines
				font
				fontSize
				bold
				rollLinkId
				version
				baseFieldTemplate
			}
			nextToken
		}
	}
`;

// EDITED
export const getProject = /* GraphQL */ `
	query GetProject($id: ID!, $formGroupNextToken: String) {
		getProject(id: $id) {
			id
			name
			description
			public
			formGroups(nextToken: $formGroupNextToken) {
				items {
					id
					users
					type
					name
					formOrder
					projectId
					formInstances {
						items {
							formTemplate {
								template
								description
								id
								fieldsOrder
								versionName
								# fieldTemplates {
								#   items {
								#     id
								#     rollLinkId
								#     inputType
								#     tableFields {
								#       items {
								#         id
								#         rollLinkId
								#       }
								#       nextToken
								#     }
								#   }
								#   nextToken
								# }
								group
								readGroups
								createdAt
								updatedAt
							}
							id
							group
							createdAt
							updatedAt
						}
						nextToken
					}
					group
					createdAt
					syncedAt
					lastUpdatedBy
					updatedAt
				}
				nextToken
			}
			forceUpdateData
			users
			group
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const getFormGroupInProject = /* GraphQL */ `
	query GetFormGroup($id: ID!) {
		getFormGroup(id: $id) {
			id
			users
			type
			name
			formOrder
			projectId
			formInstances {
				items {
					formTemplate {
						versionName
						template
						description
						id
						fieldsOrder
						group
						createdAt
						updatedAt
					}
					id
					group
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const listProjects = /* GraphQL */ `
	query ListProjects($filter: ModelProjectFilterInput, $limit: Int, $nextToken: String) {
		listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				name
				description
				public
				users
				group
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

// EDITED
export const listFormGroups = /* GraphQL */ `
	query ListFormGroups($filter: ModelFormGroupFilterInput, $limit: Int, $nextToken: String) {
		listFormGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				users
				name
				projectId
				formOrder
				group
				createdAt
				updatedAt
				lastUpdatedBy
				syncedAt
			}
			nextToken
		}
	}
`;

// EDITED
export const listFormInstances = /* GraphQL */ `
	query ListFormInstances($filter: ModelFormInstanceFilterInput, $limit: Int, $nextToken: String) {
		listFormInstances(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				formTemplateId
				formGroup
				group
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;
// EDITED
export const getFormGroup = /* GraphQL */ `
	query GetFormGroup($id: ID!) {
		getFormGroup(id: $id) {
			id
			users
			name
			formOrder
			type
			projectId
			syncedAt
			lastUpdatedBy
			formInstances {
				items {
					id
					formTemplateId
					formTemplate {
						id
						template
						description
						group
						readGroups
						createdAt
						updatedAt
						type
						versionName
						fieldTemplates {
							items {
								id
								formTemplate
								inputType
								header
								csvKey
								identityRole
								options {
									items {
										id
										label
										value
										linkedId
										docId
										group
										readGroups
										exportActions
										exportData
										createdAt
										updatedAt
									}
									nextToken
								}
								optionsOrder
								docId
								tableField
								exportActions
								exportType
								action
								actionData
								rollLinkId
								rowOrder
								placeholder
								tableFields {
									items {
										id
										formTemplate
										inputType
										action
										actionData
										header
										csvKey
										identityRole
										rollLinkId
										options {
											nextToken
											items {
												id
												label
												value
												linkedId
												docId
												group
												readGroups
												exportActions
												exportData
												createdAt
												updatedAt
											}
										}
										optionsOrder
										docId
										placeholder
										tableField
										rowOrder
										group
										readGroups
										createdAt
										updatedAt
									}
									nextToken
								}
								group
								readGroups
								createdAt
								updatedAt
							}
						}
						formTemplateGroup
						exportType
						fieldsOrder
					}
					fieldInstances {
						items {
							id
							formInstance
							fieldTemplate {
								id
								formTemplate
								inputType
								csvKey
								identityRole
								header
								options {
									items {
										id
										label
										value
										linkedId
										docId
										group
										readGroups
										exportActions
										exportData
										createdAt
										updatedAt
									}
									nextToken
								}
								optionsOrder
								docId
								tableField
								exportActions
								exportType
								action
								actionData
								rollLinkId
								rowOrder
								placeholder
								tableFields {
									items {
										id
										formTemplate
										inputType
										header
										action
										actionData
										csvKey
										identityRole
										rollLinkId
										options {
											nextToken
											items {
												id
												label
												value
												linkedId
												docId
												group
												readGroups
												exportActions
												exportData
												createdAt
												updatedAt
											}
										}
										optionsOrder
										docId
										placeholder
										tableField
										rowOrder
										group
										readGroups
										createdAt
										updatedAt
									}
									nextToken
								}
								group
								readGroups
								createdAt
								updatedAt
							}
							altInstance {
								id
								authors
								lastAuthor
								createdAt
								updatedAt
								editing
								fieldTemplateId
								formGroup
								fieldsOrder
								group
								notes
								value
								altInstanceId
							}
							altInstanceId
							formGroup
							fieldTemplateId
							value

							tableField
							tableFields {
								items {
									id
									formInstance
									formGroup
									tableField
									fieldTemplateId
									value

									authors
									group
									imageId
									image {
										id
										key
										rotation
										dpi
										aspectX
										aspectY
										createdAt
										updatedAt
										formGroup
										project
										group
									}
									createdAt
									updatedAt
								}
								nextToken
							}
							imageId
							image {
								id
								key
								rotation
								dpi
								aspectX
								aspectY
								createdAt
								updatedAt
								formGroup
								project
								group
							}
							fieldsOrder
							sortingPriority
							authors
							editing
							group
							createdAt
							updatedAt
						}
						nextToken
					}
					group
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;

// EDITED
export const getFormGroupForExport = /* GraphQL */ `
	query GetFormGroup($id: ID!) {
		getFormGroup(id: $id) {
			id
			users
			name
			formOrder
			projectId
			type
			lastUpdatedBy
			syncedAt
			formInstances {
				items {
					id
					formTemplateId
					formTemplate {
						id
						template
						description
						group
						createdAt
						updatedAt
						formTemplateGroup
						exportType
						fieldsOrder
						versionName
					}
					fieldInstances {
						items {
							id
							formInstance
							fieldTemplate {
								id
								formTemplate
								inputType
								rollLinkId
								csvKey
								identityRole
								header
								options {
									items {
										id
										label
										value
										linkedId
										docId
										group
										exportActions
										exportData
										createdAt
										updatedAt
									}
									nextToken
								}
								optionsOrder
								docId
								tableField
								exportActions
								exportType
								action
								actionData
								rowOrder
								tableFields {
									items {
										id
										formTemplate
										inputType
										rollLinkId
										header
										csvKey
										identityRole
										options {
											nextToken
											items {
												id
												label
												linkedId
												value
												docId
												group
												exportActions
												exportData
												createdAt
												updatedAt
											}
										}
										optionsOrder
										docId
										tableField
										rowOrder
										group
										createdAt
										updatedAt
									}
									nextToken
								}
								group
								createdAt
								updatedAt
							}
							altInstance {
								id
								value

								authors
								group
							}
							altInstanceId
							formGroup
							fieldTemplateId
							value

							tableField
							tableFields {
								items {
									id
									formInstance
									formGroup
									tableField
									fieldTemplateId
									fieldTemplate {
										id
										rollLinkId
										formTemplate
										inputType
										header
										csvKey
										identityRole
										options {
											items {
												id
												label
												linkedId
												value
												docId
												group
												exportActions
												exportData
												createdAt
												updatedAt
											}
											nextToken
										}
										optionsOrder
										docId
										tableField
										exportActions
										exportType
										action
										actionData
										rowOrder
										group
										createdAt
										updatedAt
									}
									value

									authors
									group
									createdAt
									updatedAt
								}
								nextToken
							}
							fieldsOrder
							sortingPriority
							authors
							editing
							group
							createdAt
							updatedAt
						}
						nextToken
					}
					group
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;

//EDITED
export const getFormGroupForDelete = /* GraphQL */ `
	query GetFormGroup($id: ID!) {
		getFormGroup(id: $id) {
			id
			name
			type
			projectId
			formInstances {
				items {
					id
					fieldInstances {
						items {
							id
							fieldTemplate {
								inputType
								id
								tableField
								action
								actionData
								formTemplate
								inputType
								header
								csvKey
								identityRole
								options {
									nextToken
								}
								tableField
								rowOrder
							}
							altInstanceId
						}
						nextToken
					}
				}
				nextToken
			}
		}
	}
`;

//EDITED
export const getFormInstance = /* GraphQL */ `
	query GetFormInstance($id: ID!, $nextToken: String) {
		getFormInstance(id: $id) {
			id
			formTemplateId
			formTemplate {
				id
				template
				description
				group
				createdAt
				updatedAt
				templateName
				version
				versionName
				publish
				createdBy
				updatedBy
				projectId
				type
				fieldTemplates {
					items {
						id
						formTemplate
						inputType
						header
						rollLinkId
						baseFieldTemplate
						csvKey
						identityRole
						options {
							items {
								id
								label
								value
								linkedId
								docId
								group
								exportActions
								exportData
								createdAt
							}
							nextToken
						}
						optionsOrder
						docId
						tableField
						exportActions
						exportType
						action
						actionData
						rowOrder
						placeholder
						tableFields {
							items {
								id
								formTemplate
								inputType
								header
								rollLinkId
								action
								actionData
								csvKey
								identityRole
								baseFieldTemplate
								options {
									nextToken
									items {
										id
										label
										linkedId
										value
										docId
										group
										exportActions
										exportData
										createdAt
										updatedAt
									}
								}
								optionsOrder
								docId
								placeholder
								tableField
								rowOrder
								group
								createdAt
								updatedAt
							}
							nextToken
						}
						group
						createdAt
						updatedAt
					}
				}
				formTemplateGroup
				exportType
				fieldsOrder
			}
			fieldInstances(nextToken: $nextToken) {
				items {
					id
					formInstance
					fieldTemplate {
						id
						formTemplate
						inputType
						header
						csvKey
						identityRole
						rollLinkId
						baseFieldTemplate
						options {
							items {
								id
								label
								value
								linkedId
								docId
								group
								exportActions
								exportData
								fieldTemplateId
								createdAt
								updatedAt
							}
							nextToken
						}
						optionsOrder
						docId
						placeholder
						tableField
						exportActions
						exportType
						action
						actionData
						rowOrder
						tableFields {
							items {
								id
								formTemplate
								inputType
								header
								rollLinkId
								csvKey
								identityRole
								options {
									nextToken
									items {
										id
										label
										value
										linkedId
										docId
										group
										fieldTemplateId
										exportActions
										exportData
										createdAt
										updatedAt
									}
								}
								optionsOrder
								docId
								action
								actionData
								placeholder
								tableField
								rowOrder
								group
								createdAt
								updatedAt
							}
							nextToken
						}
						group
						createdAt
						updatedAt
					}
					altInstance {
						id
						value

						authors
						group
					}
					altInstanceId
					formGroup
					fieldTemplateId
					value

					tableField
					tableFields {
						items {
							id
							formInstance
							formGroup
							fieldTemplate {
								id
								formTemplate
								inputType
								header
								csvKey
								identityRole
								rollLinkId
								baseFieldTemplate
								options {
									items {
										id
										label
										value
										linkedId
										docId
										group
										fieldTemplateId
										exportActions
										exportData
										createdAt
										updatedAt
									}
									nextToken
								}
								optionsOrder
								docId
								placeholder
								tableField
								exportActions
								exportType
								action
								actionData
								rowOrder
								group
								createdAt
								updatedAt
							}
							tableField
							fieldTemplateId
							value
							altInstanceId
							altInstance {
								id
								value
								authors
								group
							}
							notes
							editing
							authors
							group
							imageId
							image {
								id
								key
								rotation
								dpi
								aspectX
								aspectY
								createdAt
								updatedAt
								formGroup
								project
								group
							}
							createdAt
							updatedAt
						}
						nextToken
					}
					imageId
					image {
						id
						key
						rotation
						dpi
						aspectX
						aspectY
						createdAt
						updatedAt
						formGroup
						project
						group
					}
					fieldsOrder
					sortingPriority
					authors
					editing
					group
					createdAt
					updatedAt
				}
				nextToken
			}
			group
			createdAt
			updatedAt
		}
	}
`;

//EDITED
export const getFieldInstance = /* GraphQL */ `
	query GetFieldInstance($id: ID!) {
		getFieldInstance(id: $id) {
			id
			formInstance
			formGroup
			fieldTemplate {
				id
				formTemplate
				inputType
				header
				tableField
				action
				actionData
				rowOrder
				csvKey
				identityRole
				tableFields {
					nextToken
				}
				options {
					nextToken
				}
				optionsOrder
				docId
				placeholder
				group
				readGroups
				createdAt
				updatedAt
			}
			fieldTemplateId
			value
			altInstance {
				id
				formInstance
				formGroup
				fieldTemplate {
					id
					formTemplate
					inputType
					header
					tableField
					rollLinkId
					action
					actionData
					rowOrder
					optionsOrder
					docId
					placeholder
					group
					readGroups
					csvKey
					identityRole
					createdAt
					updatedAt
				}
				fieldTemplateId
				value
				altInstance {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder
					sortingPriority
					notes
					authors
					editing
					group
					createdAt
					updatedAt
				}
				altInstanceId
				tableField
				fieldsOrder
				sortingPriority
				tableFields {
					nextToken
				}

				notes
				authors
				editing
				group
				createdAt
				updatedAt
			}
			altInstanceId
			tableField
			fieldsOrder
			sortingPriority
			tableFields {
				items {
					id
					formInstance
					formGroup
					fieldTemplateId
					value
					altInstanceId
					tableField
					fieldsOrder
					sortingPriority
					notes
					authors
					editing
					group
					imageId
					image {
						id
						key
						rotation
						dpi
						aspectX
						aspectY
						createdAt
						updatedAt
						formGroup
						project
						group
					}
					createdAt
					updatedAt
				}
				nextToken
			}
			forceUpdateData

			notes
			authors
			imageId
			image {
				id
				key
				rotation
				dpi
				aspectX
				aspectY
				createdAt
				updatedAt
				formGroup
				project
				group
			}
			editing
			group
			createdAt
			updatedAt
		}
	}
`;

// NEW EDITED
// MAKE SURE TO RE MAKE THIS IF YOU HAVE AMPLIFY REMAKE THESE FILES!! OTHERWISE YOU WILL AHVE TO REMAKE
// IT MANUALLY BRAHHH
export const getTableInstance = /* GraphQL */ `
	query GetFieldInstance($id: ID!, $nextToken: String) {
		getFieldInstance(id: $id) {
			id
			tableFields(nextToken: $nextToken) {
				items {
					id
					fieldTemplateId
					fieldTemplate {
						id
						formTemplate
						inputType
						header
						action
						actionData
						tableField
						rowOrder
						optionsOrder
						rollLinkId
						docId
						csvKey
						identityRole
						placeholder
						options {
							nextToken
							items {
								id
								label
								value
								linkedId
								docId
								group
								readGroups
								exportActions
								exportData
								createdAt
								updatedAt
							}
						}
					}
					imageId
					image {
						id
						key
						rotation
						dpi
						aspectX
						aspectY
						createdAt
						updatedAt
						formGroup
						project
						group
					}
					group
					createdAt
					updatedAt
					tableField
					group

					editing
					authors
					formGroup
					value
					altInstanceId
					altInstance {
						id
						value
						authors
						group
					}
				}
				nextToken
			}
		}
	}
`;

export const getCellsByTableField = /* GraphQL */ `
	query GetCells($tableId: ID!, $nextToken: String) {
		fieldInstancesByTableField(tableField: $tableId, nextToken: $nextToken) {
			items {
				id
				fieldTemplateId
				fieldTemplate {
					id
					formTemplate
					inputType
					header
					action
					actionData
					tableField
					rowOrder
					optionsOrder
					rollLinkId
					docId
					csvKey
					identityRole
					placeholder
					options {
						nextToken
						items {
							id
							label
							value
							linkedId
							docId
							group
							readGroups
							exportActions
							exportData
							createdAt
							updatedAt
						}
					}
				}
				imageId
				image {
					id
					key
					rotation
					dpi
					aspectX
					aspectY
					createdAt
					updatedAt
					formGroup
					project
					group
				}
				group
				createdAt
				updatedAt
				tableField
				group

				editing
				authors
				formGroup
				value
				altInstanceId
				altInstance {
					id
					value
					authors
					group
				}
			}
			nextToken
		}
	}
`;

export const getUser = /* GraphQL */ `
	query GetUser($id: ID!) {
		getUser(id: $id) {
			id
			username
			group
			hideTutorial
			lightMode
			email
			isDeveloper
			# messages {
			# 	items {
			# 		id
			# 		userId
			# 		messageId
			# 		group
			# 		read
			# 		message {
			# 			from
			# 			subject
			# 			message
			# 			id
			# 			group
			# 			projects
			# 			createdAt
			# 		}
			# 	}
			# 	nextToken
			# }
			roleIds
			roles {
				id
				name
				description
				createdAt
				updatedAt
				readGroups
				group
				permissionIds
				permissions {
					id
					name
					value
					description
					group
					createdAt
					updatedAt
				}
			}
			createdAt
			updatedAt
		}
	}
`;

export const batchGetFormGroupsWithFormInstancesAndTemplatesByIds = /* GraphQL */ `
	query BatchGetFormGroups($ids: [ID]) {
		batchGetFormGroups(ids: $ids) {
			id
			users
			name
			projectId
			type
			formOrder
			group
			createdAt
			updatedAt
			syncedAt
			lastUpdatedBy
			formInstances {
				items {
					id
					formTemplateId
					group
					formGroup
					exportInstruction
					formTemplate {
						id
						template
						type
						description
						fieldsOrder
						formTemplateGroup
						exportType
						createdAt
						updatedAt
						templateName
						version
						versionName
						projectId
						group
						readGroups
					}
				}
			}
		}
	}
`;

// ALL OF THESE QUERIES BELOW HERE ARE FOR THE SYNCING FLOWS (JSON AND SYNC MENU)

export const batchGetFormGroupsByIds = /* GraphQL */ `
	query BatchGetFormGroups($ids: [ID]) {
		batchGetFormGroups(ids: $ids) {
			id
			users
			name
			projectId
			type
			formOrder
			group
			createdAt
			updatedAt
			syncedAt
			lastUpdatedBy
		}
	}
`;

export const batchGetRevisionsByFieldInstance = /* GraphQL */ `
	query BatchGetRevisionsByFieldInstance($fieldInstanceId: ID!, $nextToken: String) {
		revisionsByFieldInstance(fieldInstance: $fieldInstanceId, nextToken: $nextToken) {
			items {
				id
				value
				author
				fieldInstance
				formGroup
				group
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const batchGetRevisionsByFormGroup = /* GraphQL */ `
	query BatchGetRevisionsByFormGroup($formGroup: ID!, $nextToken: String) {
		revisionsByFormGroup(formGroup: $formGroup, nextToken: $nextToken) {
			items {
				id
				value
				author
				fieldInstance
				formGroup
				group
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const formGroupsByProject = /* GraphQL */ `
	query FormGroupsByProject($projectId: ID!, $nextToken: String) {
		formGroupsByProjectId(projectId: $projectId, nextToken: $nextToken) {
			items {
				id
				formOrder
				type
				group
				projectId
				name
				users
				createdAt
				updatedAt
				lastUpdatedBy
				syncedAt
			}
			nextToken
		}
	}
`;

export const formInstancesByFormGroup = /* GraphQL */ `
	query GetFormInstancesByFormGroupId($formGroup: ID!, $nextToken: String) {
		formInstancesByFormGroup(formGroup: $formGroup, nextToken: $nextToken) {
			items {
				id
				formTemplateId
				group
				formGroup
				exportInstruction
			}
			nextToken
		}
	}
`;

export const formInstancesWithFormTemplatesByFormGroup = /* GraphQL */ `
	query GetFormInstancesByFormGroupId($formGroup: ID!, $nextToken: String) {
		formInstancesByFormGroup(formGroup: $formGroup, nextToken: $nextToken) {
			items {
				id
				formTemplateId
				formTemplate {
					createdAt
					createdBy
					deleted
					description
					exportType
					fieldsOrder
					formTemplateGroup
					group
					readGroups
					id
					imagesPerPage
					projectId
					publish
					template
					templateName
					type
					updatedAt
					updatedBy
					version
					versionName
				}
				group
				formGroup
				exportInstruction
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const fieldInstancesByFormGroup = /* GraphQL */ `
	query GetFieldInstancesByFormGroupId($formGroup: ID!, $nextToken: String) {
		fieldInstancesByFormGroup(formGroup: $formGroup, nextToken: $nextToken) {
			items {
				id
				formInstance
				formGroup
				fieldTemplateId
				value
				altInstanceId
				imageId
				tableField
				fieldsOrder
				sortingPriority
				notes
				forceUpdateData
				exportInstruction
				authors
				editing
				group
				lastAuthor
				updatedAt
				createdAt
			}
			nextToken
		}
	}
`;

export const fieldInstancesWithTemplatesByFormGroup = /* GraphQL */ `
	query GetFieldInstancesByFormGroupId($formGroup: ID!, $nextToken: String) {
		fieldInstancesByFormGroup(formGroup: $formGroup, nextToken: $nextToken) {
			items {
				id
				formInstance
				formGroup
				fieldTemplateId
				fieldTemplate {
					id
					formTemplate
					inputType
					exportType
					exportActions
					header
					tableField
					action
					actionData
					rowOrder
					deleted
					optionsOrder
					exportData
					docId
					group
					readGroups
					createdAt
					updatedAt
					continuationDataId
					placeholder
					pixelFollowing
					pixelInitial
					rowsAllowed
					totalExtraLines
					font
					fontSize
					bold
					rollLinkId
					legacyHeader
					csvKey
					identityRole
					options {
						items {
							id
							fieldTemplateId
							formTemplate
							label
							value
							docId
							group
							readGroups
							exportData
							exportActions
							linkedId
							deleted
							createdAt
							updatedAt
						}
						nextToken
					}
				}
				value
				altInstanceId
				imageId
				tableField
				fieldsOrder
				sortingPriority
				notes
				forceUpdateData
				exportInstruction
				authors
				editing
				group
				lastAuthor
				updatedAt
				createdAt
			}
			nextToken
		}
	}
`;

export const batchGetFormTemplatesByIds = /* GraphQL */ `
	query BatchGetFormTemplates($ids: [ID]) {
		batchGetFormTemplates(ids: $ids) {
			id
			template
			type
			description
			fieldsOrder
			formTemplateGroup
			imagesPerPage
			exportType
			createdAt
			updatedAt
			deleted
			exportInstruction
			templateName
			version
			versionName
			publish
			createdBy
			updatedBy
			projectId
			group
			readGroups
		}
	}
`;

export const getFieldTemplatesByFormTemplate = /* GraphQL */ `
	query GetFieldTemplatesByFormTemplateId($formTemplate: ID!, $nextToken: String) {
		fieldTemplatesByFormTemplate(formTemplate: $formTemplate, nextToken: $nextToken) {
			items {
				id
				action
				actionData
				createdAt
				deleted
				exportData
				exportType
				exportActions
				formTemplate
				header
				inputType
				optionsOrder
				rowOrder
				tableField
				csvKey
				identityRole
				docId
				continuationDataId
				continuationData {
					id
					continuationActions
					createdAt
					updatedAt
					fieldTemplateId
					formTemplateId
					instanceToContinueOn
					parentFormTemplateId
					group
					readGroups
				}
				placeholder
				pixelFollowing
				pixelInitial
				rowsAllowed
				totalExtraLines
				font
				fontSize
				bold
				rollLinkId
				version
				baseFieldTemplate
				group
				readGroups
				updatedAt
			}
			nextToken
		}
	}
`;

export const getOptionsByFormTemplate = /* GraphQL */ `
	query GetOptionsByFormTemplateId($formTemplate: ID!, $nextToken: String) {
		optionsByFormTemplate(formTemplate: $formTemplate, nextToken: $nextToken) {
			items {
				id
				fieldTemplateId
				formTemplate
				label
				value
				docId
				group
				readGroups
				exportData
				exportActions
				linkedId
				deleted
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

/** edited */
export const getFieldContinuationDataByParentFormTemplateId = /* GraphQL */ `
	query GetFieldContinuationDataByParentFormTemplateId($parentFormTemplateId: ID!, $nextToken: String) {
		fieldContinuationDataByParentFormTemplateId(parentFormTemplateId: $parentFormTemplateId, nextToken: $nextToken) {
			items {
				id
				continuationActions
				fieldTemplateId
				formTemplateId
				parentFormTemplateId
				instanceToContinueOn
				group
				readGroups
			}
			nextToken
		}
	}
`;

export const getImagesByFormGroup = /* GraphQL */ `
	query GetImagesByFormGroup($formGroup: ID!, $nextToken: String) {
		imagesByFormGroup(formGroup: $formGroup, nextToken: $nextToken) {
			items {
				id
				key
				rotation
				dpi
				aspectX
				aspectY
				createdAt
				updatedAt
				formGroup
				project
				group
			}
			nextToken
		}
	}
`;

export const getSignedS3Url = /* GraphQL */ `
	query GetSignedS3Url($key: String!) {
		getSignedS3Url(key: $key)
	}
`;

export const getCognitoUsersByGroup = /* GraphQL */ `
	query GetCognitoUsersByGroup($group: String!) {
		getCognitoUsers(group: $group) {
			Username
			UserCreateDate
			UserLastModifiedDate
			Enabled
			UserStatus
			MFAOptions {
				value
				name
			}
			Attributes {
				name
				value
			}
		}
	}
`;

export const listUsers = /* GraphQL */ `
	query ListUsers($nextToken: String) {
		listUsers(nextToken: $nextToken) {
			nextToken
			items {
				createdAt
				email
				group
				hideTutorial
				id
				isDeveloper
				lightMode
				updatedAt
				username
				roleIds
				roles {
					createdAt
					description
					group
					permissionIds
					name
					id
					readGroups
					updatedAt
					permissions {
						createdAt
						description
						group
						id
						name
						updatedAt
						value
					}
				}
			}
		}
	}
`;

export const listRoles = /* GraphQL */ `
	query ListRoles($nextToken: String) {
		listRoles(nextToken: $nextToken) {
			items {
				id
				createdAt
				description
				group
				name
				readGroups
				permissionIds
				updatedAt
				permissions {
					createdAt
					group
					id
					name
					value
				}
			}
			nextToken
		}
	}
`;

export const listPermissions = /* GraphQL */ `
	query ListPermissions($nextToken: String) {
		listPermissions(nextToken: $nextToken) {
			items {
				id
				createdAt
				description
				group
				name
				value
				updatedAt
			}
			nextToken
		}
	}
`;
export const getProjectTemplates = /* GraphQL */ `
	query GetProjectTemplates($projectId: String!) {
		getProjectTemplates(projectId: $projectId)
	}
`;

// Analytics Event Queries
export const getAnalyticsEvent = /* GraphQL */ `
	query GetAnalyticsEvent($id: ID!) {
		getAnalyticsEvent(id: $id) {
			id
			eventType
			userId
			groupId
			timestamp
			clientTimestamp
			sessionId
			deviceType
			metadata
			appVersion
			offlineQueued
			ttl
		}
	}
`;

export const listAnalyticsEvents = /* GraphQL */ `
	query ListAnalyticsEvents($filter: ModelAnalyticsEventFilterInput, $limit: Int, $nextToken: String) {
		listAnalyticsEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				eventType
				userId
				groupId
				timestamp
				clientTimestamp
				sessionId
				deviceType
				metadata
				appVersion
				offlineQueued
			}
			nextToken
		}
	}
`;

export const listAnalyticsEventsByUserId = /* GraphQL */ `
	query ListAnalyticsEventsByUserId(
		$userId: String!
		$timestamp: ModelStringKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelAnalyticsEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		listAnalyticsEventsByUserId(
			userId: $userId
			timestamp: $timestamp
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				userId
				groupId
				timestamp
				clientTimestamp
				sessionId
				deviceType
				metadata
				appVersion
				offlineQueued
			}
			nextToken
		}
	}
`;

export const listAnalyticsEventsByGroupId = /* GraphQL */ `
	query ListAnalyticsEventsByGroupId(
		$groupId: String!
		$timestamp: ModelStringKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelAnalyticsEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		listAnalyticsEventsByGroupId(
			groupId: $groupId
			timestamp: $timestamp
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				userId
				groupId
				timestamp
				clientTimestamp
				sessionId
				deviceType
				metadata
				appVersion
				offlineQueued
			}
			nextToken
		}
	}
`;

export const listAnalyticsEventsBySessionId = /* GraphQL */ `
	query ListAnalyticsEventsBySessionId(
		$sessionId: String!
		$timestamp: ModelStringKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelAnalyticsEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		listAnalyticsEventsBySessionId(
			sessionId: $sessionId
			timestamp: $timestamp
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				userId
				groupId
				timestamp
				clientTimestamp
				sessionId
				deviceType
				metadata
				appVersion
				offlineQueued
			}
			nextToken
		}
	}
`;

export const listAnalyticsEventsByEventType = /* GraphQL */ `
	query ListAnalyticsEventsByEventType(
		$eventType: String!
		$timestamp: ModelStringKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelAnalyticsEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		listAnalyticsEventsByEventType(
			eventType: $eventType
			timestamp: $timestamp
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				userId
				groupId
				timestamp
				clientTimestamp
				sessionId
				deviceType
				metadata
				appVersion
				offlineQueued
			}
			nextToken
		}
	}
`;

export const listAnalyticsEventsByTimestamp = /* GraphQL */ `
	query ListAnalyticsEventsByTimestamp(
		$timestamp: AWSDateTime!
		$eventType: ModelStringKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelAnalyticsEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		listAnalyticsEventsByTimestamp(
			timestamp: $timestamp
			eventType: $eventType
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				userId
				groupId
				timestamp
				clientTimestamp
				sessionId
				deviceType
				metadata
				appVersion
				offlineQueued
			}
			nextToken
		}
	}
`;

// Analytics Aggregate Queries
export const getAnalyticsAggregate = /* GraphQL */ `
	query GetAnalyticsAggregate($id: ID!) {
		getAnalyticsAggregate(id: $id) {
			id
			metricType
			period
			value
			groupId
			metadata
			ttl
		}
	}
`;

export const listAnalyticsAggregates = /* GraphQL */ `
	query ListAnalyticsAggregates($filter: ModelAnalyticsAggregateFilterInput, $limit: Int, $nextToken: String) {
		listAnalyticsAggregates(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				metricType
				period
				value
				groupId
				metadata
				ttl
			}
			nextToken
		}
	}
`;
